import _Promise from "@babel/runtime-corejs2/core-js/promise";
import { createHistory } from 'history';
import { useRouterHistory, createMemoryHistory } from 'react-router';
export var baseNameRouter = {
  /**
   * Set a basename into the router configuration for the server.
   */
  server: function server(basename) {
    return function (store, req) {
      var history = createMemoryHistory({
        basename: basename
      });
      var location = history.createLocation(req.url.replace(basename, '') || '/');
      var routerOptions = {
        history: history,
        location: location
      };
      return _Promise.resolve(routerOptions);
    };
  },
  /**
   * Set a basename into the router configuration for the client.
   */
  client: function client(basename) {
    return function () {
      var history = useRouterHistory(createHistory)({
        basename: basename
      });
      var routerOptions = {
        history: history
      };
      return _Promise.resolve(routerOptions);
    };
  }
};